
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useLeagueRewardAdd } from '@/modules/league/tier/reward/model/add';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.TIER.REWARD.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, beforeFetch, create } = useLeagueRewardAdd();

        onMounted(() => beforeFetch());

        return { v$, model, beforeFetch, create };
    }
});
